import "./fantasysports.css";
import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useState } from "react";
import {
  adminPanel,
  appPricing,
  costFactors,
  fantasySteps,
  hireCards,
  monetizationData,
  popularGames,
  selectionCards,
  techTabs,
  techTabsData,
  userPanel,
  whyTemplate,
} from "./data";
import Marquee from "react-fast-marquee";

const Fantasysports = () => {
  const [keyActive, setKeyActive] = useState("userpanel");
  const [techTab, setTechTab] = useState("frontend");

  const handleKeyClick = (tab) => {
    setKeyActive(tab);
  };
  const handleTechClick = (tab) => {
    setTechTab(tab);
  };

  const activeData = techTabsData.find((tab) => tab.id === techTab)?.data || [];

  // works
  const [isPrevWorksDisabled, setIsPrevWorksDisabled] = useState(true);
  const [isNextWorksDisabled, setIsNextWorksDisabled] = useState(false);

  const handleWorksChange = (WorksSwiper) => {
    setIsPrevWorksDisabled(WorksSwiper.isBeginning);
    setIsNextWorksDisabled(WorksSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Fantasy sports app development company</title>

        <meta name="title" content="Fantasy sports app development company" />
        <meta
          name="description"
          content="Top rated fantasy sports app development company offering custom, scalable, and feature-rich fantasy sports app solutions."
        />

        <meta
          property="og:title"
          content="Fantasy sports app development company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/fantasy-sports-app-development-company"
        />
      </Helmet>

      <main className="fntsy_main">
        {/* hero */}
        <article className="fn_sp_hero fns_mb_80">
          <Swiper
            slidesPerView={1}
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 3000,
            }}
            loop={true}
            pagination={{
              clickable: true,
            }}
            className="fn_hero_swiper"
          >
            <SwiperSlide>
              <div className="fn_hero_swiperslide fn_hr_one">
                <div className="primary__landing-content-container"></div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="fn_hero_swiperslide fn_hr_two">
                <div className="primary__landing-content-container"></div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="fn_hero_swiperslide fn_hr_three">
                <div className="primary__landing-content-container"></div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="fn_hero_swiperslide fn_hr_four">
                <div className="primary__landing-content-container"></div>
              </div>
            </SwiperSlide>
          </Swiper>

          <div className="primary__landing-content-container">
            <div className="row fn_hero_row">
              <div className="col-lg-6">
                <h1 className="fn_sp_title">
                  Fantasy Sports App Development Company
                </h1>
                <p className="fn_sp_content">
                  Leading fantasy sports app development company specializing in
                  innovative, secure, and user-friendly fantasy gaming apps for
                  all major sports.
                </p>

                <div className="fn_hero_btn_wrap">
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="custom-ai-btn re-hero-btn"
                  >
                    {" "}
                    <div className="re-btn-txt">Get Free Consultation</div>
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </article>

        <div className="fnsy_grad_outer fns_mb_80">
          {/* build */}
          <article className="primary__landing-content-container">
            <div className="row mx-0 g-3">
              <div className="col-lg-5">
                <h3 className="fnsy_subtitle">
                  Build the <span className="fnsy_span"> Ultimate Sports</span>{" "}
                  Experience
                </h3>
              </div>
              <div className="col-lg-7">
                <p className="fnsy_subcontent">
                  Fantasy sports app development  has transformed the way fans
                  engage with their favorite games. From cricket and football to
                  basketball and baseball, millions of people are now playing
                  fantasy sports through mobile apps. Behind these apps is a
                  powerful company called a fantasy sports app development
                  company.
                </p>
              </div>
            </div>
          </article>

          {/* about */}
          <article className="primary__landing-content-container">
            <div className="fnsy_abt">
              <div className="row mx-0 g-4 fnsy_abt_row">
                <div className="col-lg-6">
                  <h3 className="fnsy_subtitle">
                    What is a{" "}
                    <span className="fnsy_span">Fantasy Sports App?</span>
                  </h3>
                  <p className="fnsy_subcontent">
                    Fantasy sports app development  has transformed the way fans
                    engage with their favorite games. From cricket and football
                    to basketball and baseball, millions of people are now
                    playing fantasy sports through mobile apps. Behind these
                    apps is a powerful company called a fantasy sports app
                    development company.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="custom-ai-btn re-hero-btn"
                  >
                    {" "}
                    <div className="re-btn-txt">Get Free Demo</div>
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
                <div className="col-lg-6 text-center">
                  <div className="fnsy_abt_img_wrap">
                    <img
                      src={require("../../../image/fantasysports/about.webp")}
                      alt="Fantasy sports app development company"
                      className="fnsy_abt_img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </article>

          <div className="fnsy_abt_grad"></div>
        </div>

        <div className="fnsy_grad_outer">
          {/* boom */}
          <article className="primary__landing-content-container fns_mb_80">
            <h3 className="fnsy_subtitle text-center">
              Why <span className="fnsy_span">Fantasy Sports Apps</span> Are
              Booming
            </h3>
            <p className="fnsy_subcontent text-center">
              Fantasy sports apps have gained more popularity due to
            </p>

            <div className="fn_boom_card_outer">
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/boom-img-one.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Increased smartphone usage</h5>
              </div>
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/boom-img-two.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Growth of the internet and mobile gaming</h5>
              </div>
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/boom-img-three.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Availability of real-time sports data</h5>
              </div>
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/boom-img-four.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Interest in competitive gaming and esports</h5>
              </div>
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/boom-img-five.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Monetization through ads, subscriptions, and contests</h5>
              </div>
            </div>

            <p className="fnsy_subcontent fnsy_bm_content ">
              According to industry reports, the global fantasy sports market is
              projected to grow to over $48 billion by 2027. This growth has
              opened up huge opportunities for businesses that partner with the
              right fantasy sports app development company.
            </p>
          </article>

          {/* benefits */}
          <article className="fnsy_benefits fns_mb_80">
            <div className="primary__landing-content-container">
              <h3 className="fnsy_subtitle fnsy_ben_title">
                <span className="fnsy_span">Benefits of </span>
                Launching a Fantasy Sports App
              </h3>
              <p className="fnsy_subcontent fnsy_ben_content">
                Working with a fantasy sports app development company allows
                businesses to unlock several benefits
              </p>

              <div className="row mx-0 fnsy_ben_row">
                <div className="col-lg-6">
                  <img
                    src={require("../../../image/fantasysports/benefits.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>
                <div className="col-lg-6">
                  <div className="fnsy_ben_card_outer">
                    <div className="fnsy_ben_card">
                      <img
                        src={require("../../../image/fantasysports/ben-img-one.webp")}
                        alt="Fantasy sports app development company"
                      />

                      <div className="fnsy_ben_cd_content">
                        <h5>Scalable Revenue</h5>
                        <p>
                          Fantasy sports apps can generate money through Entry
                          fees and winnings, Advertisements, Affiliate
                          marketing, In-app purchases and Premium memberships.
                        </p>
                      </div>
                    </div>
                    <div className="fnsy_ben_card">
                      <img
                        src={require("../../../image/fantasysports/ben-img-two.webp")}
                        alt="Fantasy sports app development company"
                      />

                      <div className="fnsy_ben_cd_content">
                        <h5>User Engagement</h5>
                        <p>
                          These apps keep users hooked with Real-time updates,
                          Leaderboards, Push notifications, Contests and
                          rewards.
                        </p>
                      </div>
                    </div>
                    <div className="fnsy_ben_card">
                      <img
                        src={require("../../../image/fantasysports/ben-img-three.webp")}
                        alt="Fantasy sports app development company"
                      />

                      <div className="fnsy_ben_cd_content">
                        <h5>Brand Recognition</h5>
                        <p>
                          A well-designed fantasy app builds a strong digital
                          presence and promotes brand visibility.
                        </p>
                      </div>
                    </div>
                    <div className="fnsy_ben_card">
                      <img
                        src={require("../../../image/fantasysports/ben-img-four.webp")}
                        alt="Fantasy sports app development company"
                      />

                      <div className="fnsy_ben_cd_content">
                        <h5>Loyal Fanbase</h5>
                        <p>
                          With regular updates, contests, and rewards,
                          businesses can create loyal user communities.
                        </p>
                      </div>
                    </div>
                    <div className="fnsy_ben_card">
                      <img
                        src={require("../../../image/fantasysports/ben-img-five.webp")}
                        alt="Fantasy sports app development company"
                      />

                      <div className="fnsy_ben_cd_content">
                        <h5>Data Monetization</h5>
                        <p>
                          Valuable user behavior and sports analytics can be
                          used for marketing, ad targeting, or third-party
                          partnerships.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* key features */}
          <article className="primary__landing-content-container fns_mb_100">
            <h3 className="fnsy_subtitle text-center">
              <span className="fnsy_span">Key Features of</span> a Fantasy
              Sports App
            </h3>
            <p className="fnsy_subcontent fns_key_content">
              A professional fantasy sports app development company builds apps
              with cutting-edge features. These include
            </p>

            <div className="fnsy_key_btns_wrap">
              <button
                className={`fnsy_key_btn ${
                  keyActive === "userpanel" ? "active" : ""
                }`}
                onClick={() => handleKeyClick("userpanel")}
              >
                User Panel Features
              </button>
              <button
                className={`fnsy_key_btn ${
                  keyActive === "adminpanel" ? "active" : ""
                }`}
                onClick={() => handleKeyClick("adminpanel")}
              >
                Admin Panel Features
              </button>
            </div>

            <div className="fnsy_key_box_outer">
              <div className="fnsy_key_box_inner">
                <div className="row mx-0 g-4 fnsy_key_box_row">
                  {(keyActive === "userpanel" ? userPanel : adminPanel).map(
                    (data, index) => (
                      <div className="col-lg-4 col-sm-6" key={index}>
                        <div className="fnsy_key_card">
                          <img
                            src={data.icon}
                            alt="Fantasy sports app development company"
                          />
                          <div className="fnsy_key_cd_content">
                            <h5>{data.title}</h5>
                            <p>{data.description}</p>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <p className="fnsy_subcontent fns_key_content fns_mt_40">
              A skilled fantasy sports app development company ensures all these
              features work smoothly and securely.
            </p>
          </article>
        </div>

        {/* types */}
        <article className="fnsy_types fns_mb_80">
          <div className="primary__landing-content-container ">
            <h3 className="fnsy_subtitle fnsy_type_title">
              Fantasy Sports App Game Types
            </h3>
            <p className="fnsy_subcontent fnsy_type_content">
              When you approach a fantasy sports app development company, you
              can choose from various game formats
            </p>

            <div className="row mx-0 g-4 fnsy_type_row">
              <div className="col-lg-3 col-sm-6">
                <div className="fnsy_types_card ty_cd_one">
                  <div className="fn_types_cd_content">
                    <h5>Daily Fantasy Sports (DFS)</h5>
                    <p>
                      Users play daily or weekly matches with instant results.
                      Example: DraftKings.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="fnsy_types_card ty_cd_two">
                  <div className="fn_types_cd_content">
                    <h5>Season-Long Fantasy Leagues</h5>
                    <p>
                      These run for an entire sports season, with long-term
                      rewards.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="fnsy_types_card ty_cd_three">
                  <div className="fn_types_cd_content">
                    <h5> Head-to-Head Contests</h5>
                    <p>One-on-one challenges between users.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="fnsy_types_card ty_cd_four">
                  <div className="fn_types_cd_content">
                    <h5>Multiplayer Tournaments</h5>
                    <p>Contests with large groups and prize pools.</p>
                  </div>
                </div>
              </div>
            </div>

            <p className="fnsy_subcontent fns_mt_30 fnsy_type_content">
              When you approach a fantasy sports app development company, you
              can choose from various game formats
            </p>
          </div>
        </article>

        {/* popular */}
        <article className="fns_mb_80">
          <h3 className="fnsy_subtitle text-center">
            <span className="fnsy_span">Popular Sports </span>
            for Fantasy App Development
          </h3>
          <p className="fnsy_subcontent text-center">
            You can target fans across various sports
          </p>

          <Marquee
            speed={40}
            autoFill
            pauseOnHover
            className="fnsy_popular_marquee"
          >
            {popularGames.map((game) => (
              <div className="fnsy_pop_wrap_outer" key={game.id}>
                <div className="fnsy_pop_wrap_inner">
                  <img
                    src={game.gameIcon}
                    alt="Fantasy sports app development company"
                  />
                  <p>{game.gameName}</p>
                </div>
              </div>
            ))}
          </Marquee>

          <p className="fnsy_subcontent fnsy_pop_content">
            A good fantasy sports app development company supports multiple
            sports and can integrate data from different leagues.
          </p>
        </article>

        {/* technology */}
        <article className="fnsy_tech fns_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="fnsy_subtitle fnsy_tech_title">
              <span className="fnsy_span">Technologies Used </span> in Fantasy
              Sports App Development
            </h3>
            <p className="fnsy_subcontent fnsy_tech_content">
              Building a powerful app requires advanced technology. A
              professional fantasy sports app development company is backed with
              futuristic techstacks
            </p>

            <div className="fnsy_tech_btn_wrap">
              {techTabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`fnsy_tech_btn ${
                    techTab === tab.id ? "active" : ""
                  }`}
                  onClick={() => handleTechClick(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="fnsy_tech_box_outer">
              <div className="fnsy_tech_box">
                <div className="row g-4">
                  {activeData.map((tech) => (
                    <div className="col-lg-3 col-sm-6" key={tech.id}>
                      <div className="fnsy_tech_card">
                        <img
                          src={tech.icon}
                          alt="Fantasy sports app development company"
                        />
                        <h6>{tech.title}</h6>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* how works */}
        <article className="primary__landing-content-container fns_mb_80">
          <h3 className="fnsy_subtitle fnsy_hw_title">
            How a <span className="fnsy_span">Fantasy Sports App </span>
            Development Company Works
          </h3>
          <p className="fnsy_subcontent text-center">
            Here’s how a fantasy sports app development company turns your idea
            into reality
          </p>

          <div className="row">
            <div className="col-lg-3"></div>
          </div>

          <>
            <Swiper
              className="fnsy_hw_swiper"
              spaceBetween={30}
              slidesPerView={4}
              modules={[Navigation]}
              navigation={{
                prevEl: ".cr_doc_prev",
                nextEl: ".cr_doc_nxt",
              }}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 10 },
                576: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 30 },
                992: { slidesPerView: 3, spaceBetween: 40 },
                1200: { slidesPerView: 4, spaceBetween: 30 },
              }}
              onSlideChange={handleWorksChange}
              onReachBeginning={() => setIsPrevWorksDisabled(true)}
              onReachEnd={() => setIsNextWorksDisabled(true)}
              onFromEdge={() => {
                setIsPrevWorksDisabled(false);
                setIsNextWorksDisabled(false);
              }}
            >
              {fantasySteps.map((step) => (
                <SwiperSlide key={step.id}>
                  <div className="fnsy_hw_card">
                    <div className={`fnsy_hw_img_wrap ${step.className}`}>
                      <img
                        src={step.image}
                        alt="Fantasy sports app development company"
                      />
                    </div>
                    <h5>{step.title}</h5>
                    <p>{step.description}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`cr_doc_prev ${
                  isPrevWorksDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevWorksDisabled ? "#ffffff8f" : "#fff",
                  cursor: isPrevWorksDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button
                className={`cr_doc_nxt ${
                  isNextWorksDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextWorksDisabled ? "#ffffff8f" : "#fff",
                  cursor: isNextWorksDisabled ? "not-allowed" : "pointer",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </>
        </article>

        {/* select */}
        <article className="fnsy_select fns_mb_80">
          <div className="primary__landing-content-container">
            <h3 className="fnsy_subtitle fnsy_slt_title">
              How to Select{" "}
              <span className="fnsy_span"> the Right Fantasy Sports</span> App
              Development Company
            </h3>
            <p className="fnsy_subcontent text-center">
              When hiring a fantasy sports app development company, keep the
              following things in mind
            </p>

            <div className="row mx-0 gy-5 fnsy_slt_row">
              {selectionCards.map((card) => (
                <div className="col-lg-4 col-sm-6" key={card.id}>
                  <div className="fnsy_slt_card">
                    <img
                      src={card.image}
                      alt="Fantasy sports app development company"
                      className="fnsy_slt_img"
                    />
                    <div className="fnsy_slt_loader"></div>
                    <h5>{card.title}</h5>
                    <p>{card.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="fnsy_subcontent fnsy_slt_content">
              A reliable fantasy sports app development company should offer
              full-cycle development, timely delivery, and great support.
            </p>
          </div>
        </article>

        {/* cost */}
        <article className="primary__landing-content-container fns_mb_100">
          <h3 className="fnsy_subtitle text-center">
            Cost of <span className="fnsy_span">Fantasy Sports App</span>{" "}
            Development
          </h3>
          <p className="fnsy_subcontent text-center">
            The cost depends on several factors
          </p>

          <div>
            <div className="fnsy_cst_mt staking-card-list">
              <div className="fnsy_cost_box">
                <div className="row mx-0 g-4 fnsy_cost_row">
                  {costFactors.map((item) => (
                    <div className="col-lg-4 col-sm-6" key={item.id}>
                      <div className="fnsy_cost_card">
                        <img
                          src={item.image}
                          alt="Fantasy sports app development company"
                        />
                        <p>{item.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="fnsy_cst_mt staking-card-list">
              <div className="fnsy_cost_box">
                <h6 className="fnsy_aprx_title">Approximate Cost</h6>
                <div className="row mx-0 g-4 fnsy_cost_row_two">
                  {appPricing.map((item) => (
                    <div className="col-xl-3 col-lg-4 col-sm-6" key={item.id}>
                      <div className="fnsy_aprx_card">
                        <h5>{item.price}</h5>
                        <p>{item.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="fnsy_subcontent fnsy_cst_content">
                  A trusted fantasy sports app development company will give you
                  a detailed quote based on your specific requirements.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* whitelabel */}
        <article className="container fns_mb_100">
          <h3 className="fnsy_subtitle text-center">
            <span className="fnsy_span">White Label </span>
            vs <span className="fnsy_span">Custom </span> Fantasy Sports App
          </h3>
          <p className="fnsy_subcontent fnsy_wt_content">
            You can either build a custom solution or use a white label app from
            a fantasy sports app development company.
          </p>

          <div className="fnsy_wt_btn_wrap">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="fnsy_wt_btn_one"
            >
              White Label Fantasy Sports App{" "}
              <span className="fnsy_wt_arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="fnsy_wt_btn_two"
            >
              Custom Fantasy Sports App
            </button>
          </div>

          <div className="fnsy_wt_box_outer">
            <div className="fnsy_wt_box">
              <div className="row mx-0 g-4">
                {whyTemplate.map((item) => (
                  <div className="col-lg-3 col-6" key={item.id}>
                    <div className="fnsy_wt_card">
                      <img
                        src={item.img}
                        alt="Fantasy sports app development company"
                      />
                      <h5>{item.title}</h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </article>

        {/* hire */}
        <article className="fnsy_hire fns_mb_100">
          <div className="primary__landing-content-container">
            <h3 className="fnsy_subtitle fnsy_hire_title">
              Why Hire a Professional Fantasy Sports App Development Company?
            </h3>
            <p className="fnsy_subcontent fnsy_hire_content">
              There are many DIY platforms and freelance developers, but hiring
              a full-scale fantasy sports app development company gives you
            </p>

            <div className="row mx-0 g-4 fnsy_hire_row">
              {hireCards.map((item) => (
                <div className="col-lg-4 col-sm-6" key={item.id}>
                  <div className="fnsy_hire_card_outer">
                    <div className="fnsy_hire_card">
                      <img
                        src={item.img}
                        alt="Fantasy sports app development company"
                      />
                      <p>{item.title}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <p className="fnsy_subcontent mt-5 fnsy_hire_content">
              They manage the entire development process, allowing you to focus
              on business strategy.
            </p>
          </div>
        </article>

        {/* legal */}
        <article className="primary__landing-content-container fns_mb_80">
          <h3 className="fnsy_subtitle fnsy_lg_title">
            <span className="fnsy_span">Legal Considerations </span>
            in Fantasy Sports App Development
          </h3>
          <p className="fnsy_subcontent text-center">
            A reliable fantasy sports app development company helps you stay
            compliant
          </p>

          <div className="row mx-0 g-4 fnsy_lg_row">
            <div className="col-lg-3">
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/lg-img-one.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Licensing</h5>
                <p>Different countries have different regulations.</p>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/lg-img-two.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Terms and Conditions</h5>
                <p>Must clearly state rules and guidelines.</p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/lg-img-three.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Fair Play</h5>
                <p>Anti-cheat mechanisms are important.</p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="fn_boom_card">
                <div className="fn_bm_img_wrap">
                  <img
                    src={require("../../../image/fantasysports/lg-img-four.webp")}
                    alt="Fantasy sports app development company"
                  />
                </div>

                <div className="fn_bm_loader"></div>
                <h5>Data Protection</h5>
                <p>GDPR and other data privacy laws must be followed.</p>
              </div>
            </div>
          </div>

          <p className="fnsy_subcontent fnsy_bm_content ">
            Legal guidance ensures smooth operation and builds user trust.
          </p>
        </article>

        {/* monetize */}
        <article className="fnsy_monetize fns_mb_80">
          <div className="primary__landing-content-container ">
            <h3 className="fnsy_subtitle text-center">
              <span className="fnsy_span">How to Monetize </span>
              Your Fantasy Sports App
            </h3>
            <p className="fnsy_subcontent fnsy_mn_content">
              A fantasy sports app development company helps you integrate
              monetization options such as
            </p>

            <div className="fnsy_mn_outer">
              <div className="fnsy_mn_inner">
                <div className="row mx-0 g-4 fnsy_mn_row">
                  {monetizationData.map((item) => (
                    <div className="col-lg-4 col-sm-6" key={item.id}>
                      <div className="fnsy_mn_card">
                        <img
                          src={item.img}
                          alt="Fantasy sports app development company"
                        />
                        <p>{item.title}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <p className="fnsy_subcontent fnsy_mn_content">
              These features drive revenue and ensure business sustainability.
            </p>
          </div>
        </article>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Fantasy sports are not just games they're a billion-dollar
              business. If you want to build a fantasy sports app, hiring the
              right fantasy sports app development company is key. They offer
              expert development, reliable support, and help turn your vision
              into a revenue-generating platform. Whether you’re targeting
              cricket fans in India or football lovers in Europe, the right app
              can transform your brand. So, don’t wait. Partner with a
              professional fantasy sports app development company and bring your
              sports startup dream to life!
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          Do fantasy sports app development companies offer
                          white-label solutions?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, many offer ready-made white-label apps that can
                          be customized with your branding. This saves time and
                          reduces development cost.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Can I integrate payment gateways into my fantasy
                          sports app?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, definitely! Most apps integrate with popular
                          payment gateways such as PayPal, Razorpay, Stripe, and
                          UPI, ensuring safe and seamless transactions.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Is operating a fantasy sports app legally permitted?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Fantasy sports are legal in many countries if they are
                          skill-based games. Always consult legal experts and
                          follow local laws and licensing.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Can I launch the app on both Android and iOS?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, the app can be built for both platforms using
                          native or cross-platform development. This helps you
                          reach a both iOS and android audience.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          How can I attract users to my fantasy sports app?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          You can use digital marketing, referral bonuses,
                          social media, and influencer campaigns. A development
                          company may also help with promotion strategies.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Fantasysports;
